// @flow
import $ from "../vendor/jquery";

import global, {menu_translate, clear_old_page, getWagonInfo} from "./Global";
import Wagons from "./Wagons";
import {activateMenuItem} from "../util";
import t from "../trans";
import Legacy from "../Legacy";
import ProductTransformer from "../ProductTransformer";

/**
 * Tolerantside moodul
 *
 */
class Tolerances {
    /**
     * @type {?Tolerances}
     */
    static tolerancesIntance = null;

    /**
     *
     * @returns {Tolerances}
     */
    static getInstance() {
        if (Tolerances.tolerancesIntance == null) Tolerances.tolerancesIntance = new Tolerances();
        return Tolerances.tolerancesIntance;
    }

    make_tolerances_page(n) {

        menu_translate();
        clear_old_page();

        if (n < 0) {
            if (global.current_shown_wagon < 0) global.current_shown_wagon = global.current_wagon;
            n = global.current_shown_wagon;
        } else {
            global.current_shown_wagon = n;
        }

        let drow = null;
        if (global.archive_mode) {
            drow = global.a_measurement;
        } else {
            if ($("#tolerances_li").hasClass("active")) return;
            activateMenuItem("tolerances");
            $("#content").html("");
            drow = Legacy.getDrow();
        }
        if (!drow) return;

        // header text
        let s = "<span class='' ";
        s += " style='margin-bottom: 10px;'>";
        s += getWagonInfo(drow);
        s += "</span>";
        $("#topy").css("height", "20px");
        $("#intop2").html(s);
        s = "";
        $("#intop1").html(s);
        $(".mbtn").button("toggle");
        // data
        let req = drow["required"]; // "corr_required"
        // content table
        s = "<div style='margin-left: 60px; margin-top: 18px'>";
        s += "<br><b>" + t("Tolerances") + "</b><p>";
        s += "<table>";
        s += "<tr class='gridtablehead'>";

        let wagons = Wagons.getInstance();

        let pointCount = 0;
        let points = wagons.getPointNumbers();
        if (drow.lineinfo) {
            for (let i = 0; i < points.length; i++) {
                if (drow.lineinfo[points[i]] == null) {
                    s += "<th>P"+(points[i]+1)+"</th>";
                    continue;
                }
                switch (drow.lineinfo[points[i]][1].substring(0, 1)) {
                    case "A":
                    case "B":
                    case "C":
                        s += "<th>P"+(points[i]+1)+"</th>";
                        break;
                    case "P":
                    default:
                        s += "<th>"+drow.lineinfo[points[i]][1]+"</th>";
                        break;
                }
            }
            pointCount = points.length;
        }
        /*
        var pointCount = settings.getMeasurementLineCount() * 3;
        for (var i = 1; i <= pointCount; i++ ) {
            s += "<th>P"+i+"</th>";
        }
        */
        // "<th>P1</th><th>P2</th><th>P3</th><th>P4</th><th>P5</th><th>P6</th><th>P7</th><th>P8</th><th>P9</th></tr>";
        s += "</tr><tr><td colspan='"+pointCount+"' style='background-color: #ff3333; height: 10px;'></td></tr>";
        for (let r = 1; r < 6; r++) {
            s += "<tr class='tolerancerow trow_" + r + "'>";
            for (let c = 1; c <= pointCount; c++) {
                let k = 0;
                if (r == 1)
                    k = 3;
                else if (r == 2)
                    k = 1;
                else if (r == 3)
                    k = 0;
                else if (r == 4)
                    k = 2;
                else if (r == 5)
                    k = 4;
                if (ProductTransformer.isCenterPoint(drow.lineinfo[points[c-1]][1])) s += "<td class='toleranceshowcell_imp'>";
                else s += "<td class='toleranceshowcell'>";
                let val = "";
                try {
                    val =  (Math.round(req[points[c - 1]][k])) / 10;
                } catch (err) {
                }
                s += val + "</td>";
            }
            s += "</tr>";
        }
        s += "<tr><td colspan='"+pointCount+"' style='background-color: #ff3333; height: 10px;'></td></tr>";
        s += "<tr><td colspan='"+pointCount+"' style='background-color: white; height: 50px;'><b>" + t("Measurement")
            + "</b></td></tr>";
        s += "<tr>";
        let val = drow["analyzed"];
        for (let c = 1; c <= pointCount; c++) {
            try {
                let cvalue = val[points[c - 1]][2];
                cvalue = (Math.round(cvalue)) / 10;
                // AA: -100 is a result of missing data; TODO: raw data should
                // be set null earlier
                if (cvalue == -100) cvalue = "";

                if (ProductTransformer.isCenterPoint(drow.lineinfo[points[c-1]][1])) s += "<td class='toleranceshowcell_imp'>";
                else s += "<td class='toleranceshowcell'>";
                s += cvalue + "</td>";
            } catch (err) {
                s += "<td class='toleranceshowcell'></td>";
            }
        }
        s += "</tr></table></div>";
        if (global.archive_mode)
            $("#a_tolerances_content").html(s);
        else
            $("#content").html(s);
    }
}

export default Tolerances;
